
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/rest-api-getting-started",
      function () {
        return require("private-next-pages/learn/rest-api-getting-started.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/rest-api-getting-started"])
      });
    }
  